import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Tags, TagsUpsert } from '../../_objects/tags';
import { TagsSchema } from '../../_offline/models/tags.schema';
import { TagsDbService } from '../database/tags-db.service';
import { TagsContractService } from '../interfaces/tags-contract.service';

@Injectable({
  providedIn: 'root'
})
export class TagsOfflineService implements TagsContractService {

  constructor(private tagsDbService: TagsDbService) { }

  getTags(): Observable<Tags> {
    return this.tagsDbService.getAll()
      .pipe(map((value: TagsSchema) => this.tagsParseToSchema(value)));
  }

  upsertTags(tagsUpsert: TagsUpsert): Observable<Tags> {
    return this.tagsDbService.getAll().pipe(
      map(existing => this.buildTagsSchema(existing, tagsUpsert)),
      switchMap(row  => this.saveTagsSchema(row)),
      map(schema     => this.tagsParseToSchema(schema))
    );
  }

  private buildTagsSchema(existing: TagsSchema | null, upsert: TagsUpsert): TagsSchema {

    const tenantId = existing?.tenantId ?? this.tagsDbService.tenantId;
    const now      = new Date().toISOString();

    const row              = existing ?? new TagsSchema(tenantId);
    row.items              = JSON.stringify(upsert.items);
    row.schemaVersion      = upsert.schemaVersion;
    row.isDeleted          = false;
    row.isValid            = true;
    row.lastUpdateDate     = now;
    row.lastUpdatedBy      = tenantId;
    row.tenantId           = tenantId;
    return row;
  }

  private saveTagsSchema(row: TagsSchema): Observable<TagsSchema> {
    return this.tagsDbService.putAll(row).pipe(
      map(list => list.find(r => r.tenantId === row.tenantId)!)
    );
  }

private tagsParseToSchema(value: TagsSchema) {
    const result =  new Tags();
    if (value) {
      result.id = value.id;
      result.items = JSON.parse(value.items);
      result.isDeleted = value.isDeleted;
      result.isValid = value.isValid;
      result.createDate = value.createDate;
      result.lastUpdateDate = value.lastUpdateDate;
      result.schemaVersion = value.schemaVersion;
      result.createdBy = value.createdBy;
      result.lastUpdatedBy = value.lastUpdatedBy;
    } else {
      result.items = [];
    }
    return result;
  }
}
